import PersonalLogin from './PersonalLogin';
import PortalSelector from './PortalSelector';

// Dominios que deben mostrar el login de personal/gestión
const INTRANET_HOSTNAMES = [
    'intranet.orionelite.edu.pe',
    // Agrega aquí otros dominios o subdominios de intranet si los necesitas
];

/**
 * Login inteligente basado en dominio:
 * - intranet.orionelite.com  → Login de Personal (Glassmorphism)
 * - aulavirtual.orionelite.com (u otro) → PortalSelector (Colegio / Academia)
 * - localhost (desarrollo) → PortalSelector por defecto
 */
const Login = () => {
    const hostname = window.location.hostname.toLowerCase();
    const isIntranet = INTRANET_HOSTNAMES.some(h => hostname.includes(h));

    if (isIntranet) {
        return <PersonalLogin />;
    }

    return <PortalSelector />;
};

export default Login;
